import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RouteModel} from "../../../routes/models/route.model";
import {MultiVolumeModel} from "../../../commons/models/multi-volume.model";
import {ModelListWithCursor} from "../../../commons/angular/models/model-list-with-cursor.model";

export interface AddToRouteResponse {
  list: ModelListWithCursor<RouteModel>;
  deliveryIds: string[];
  stopoverIds: string[];
  requiredSkills: string[];
  totalDistance: number;
  optimizedDistance: number;
  totalPrice: number;
  agentPrice: number;
  volume: MultiVolumeModel;
}

@Injectable({providedIn: 'root'})
export class AddToRouteHttpService {

  private base_url = `/services/actions/addToRoute`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAssignRouteData(queryParams: { [key: string]: any } = {}): Observable<AddToRouteResponse> {
    let params = new HttpParams();
    Object.keys(queryParams).forEach((key) => {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params = params.append(key, item.toString());
          });
        } else {
          params = params.set(key, value.toString());
        }
      }
    });
    return this.http.get<AddToRouteResponse>(this.base_url, {params});
  }

}
